import { Types as TYPES } from '../types';
import { States as STATES } from '../states';

const actionType = TYPES.find((type) => type.actionName === 'dashboardAction');
const {
    ALL_PARTICIPANT_FETCH_START,
    ALL_PARTICIPANT_FETCH_SUCCESS,
    ALL_PARTICIPANT_FETCH_FAILED,
    ALL_PARTICIPANT_FETCH_EMPTY,
    ALL_PARTICIPANT_FETCH_STOP,

    SINGLE_PARTICIPANT_FETCH_START,
    SINGLE_PARTICIPANT_FETCH_SUCCESS,
    SINGLE_PARTICIPANT_FETCH_FAILED,
    SINGLE_PARTICIPANT_FETCH_STOP,

    PARTICIPANT_CREATE_START,
    PARTICIPANT_CREATE_SUCCESS,
    PARTICIPANT_CREATE_FAILED,
    PARTICIPANT_CREATE_STOP,

    PARTICIPANT_UPDATE_START,
    PARTICIPANT_UPDATE_SUCCESS,
    PARTICIPANT_UPDATE_FAILED,
    PARTICIPANT_UPDATE_STOP,

    PARTICIPANT_DELETE_START,
    PARTICIPANT_DELETE_SUCCESS,
    PARTICIPANT_DELETE_FAILED,
    PARTICIPANT_DELETE_STOP,

    PARTICIPANT_ARCHIVE_START,
    PARTICIPANT_ARCHIVE_SUCCESS,
    PARTICIPANT_ARCHIVE_FAILED,
    PARTICIPANT_UNARCHIVE_STOP,
} = actionType.types;

const reducerState = STATES.find(
    (state) => state.reducerName === 'dashboardReducer'
);
const { initialState } = reducerState;

export default function dashboardReducer(state = initialState, action) {
    switch (action.type) {
        case ALL_PARTICIPANT_FETCH_START:
            return {
                ...state,
                status: 'all_participant_fetch_start',
                isLoading: true,
            };
        case ALL_PARTICIPANT_FETCH_SUCCESS:
            return {
                ...state,
                status: 'all_participant_fetch_success',
                allParticipantData: action.payload,
                isLoading: false,
            };
        case ALL_PARTICIPANT_FETCH_FAILED:
            return {
                ...state,
                status: 'all_participant_fetch_failed',
                isLoading: false,
            };
        case ALL_PARTICIPANT_FETCH_EMPTY:
            return {
                ...state,
                status: 'all_participant_fetch_empty',
                isLoading: false,
                allParticipantData: [],
            };
        case SINGLE_PARTICIPANT_FETCH_START:
            return {
                ...state,
                status: 'single_participant_fetch_start',
            };
        case SINGLE_PARTICIPANT_FETCH_SUCCESS:
            return {
                ...state,
                status: 'single_participant_fetch_success',
                singleParticipantData: action.payload,
            };
        case SINGLE_PARTICIPANT_FETCH_FAILED:
            return {
                ...state,
                status: 'single_participant_fetch_failed',
            };
        case PARTICIPANT_CREATE_START:
            return {
                ...state,
                status: 'participant_create_start',
            };
        case PARTICIPANT_CREATE_SUCCESS:
            return {
                ...state,
                status: 'participant_create_success',
                participantCreateData: action.payload,
            };
        case PARTICIPANT_CREATE_FAILED:
            return {
                ...state,
                status: 'participant_create_failed',
            };
        case PARTICIPANT_UPDATE_START:
            return {
                ...state,
                status: 'participant_update_start',
            };
        case PARTICIPANT_UPDATE_SUCCESS:
            return {
                ...state,
                status: 'participant_update_success',
                participantUpdateData: action.payload,
            };
        case PARTICIPANT_UPDATE_FAILED:
            return {
                ...state,
                status: 'participant_update_failed',
            };
        case PARTICIPANT_ARCHIVE_START:
            return {
                ...state,
                status: 'participant_archive_start',
            };
        case PARTICIPANT_ARCHIVE_SUCCESS:
            return {
                ...state,
                status: 'participant_archive_success',
                data: action.payload,
            };
        case PARTICIPANT_ARCHIVE_FAILED:
            return {
                ...state,
                status: 'participant_archive_failed',
            };
        case PARTICIPANT_DELETE_START:
            return {
                ...state,
                status: 'participant_delete_start',
            };
        case PARTICIPANT_DELETE_SUCCESS:
            return {
                ...state,
                status: 'participant_delete_success',
                data: state.allParticipantData.filter(
                    (participant) => participant.id !== action.payload.id
                ),
            };
        case PARTICIPANT_DELETE_FAILED:
            return {
                ...state,
                status: 'participant_delete_failed',
            };
        default:
            return {
                ...state,
            };
    }
}
